<script lang="ts">
  const {
    date,
    theme,
  }: {
    date: string;
    theme: string;
  } = $props();

  const dateObject = new Date(date);
</script>

<div
  data-theme="theme"
  class={`
   2xl:fluid-w-[80] 2xl:fluid-h-[80] flex h-[64px] w-[64px] flex-col items-center justify-center font-bold lg:h-[80px] lg:w-[80px]
  ${theme === 'green' ? 'text-black-1000 [background-image:var(--gradient-green)]' : ''}
  ${theme === 'orange' ? 'text-black-1000 [background-image:var(--gradient-orange)]' : ''}
  ${theme === 'purple' ? 'text-black-1000 [background-image:var(--gradient-purple)]' : ''}
  ${theme === 'black' ? 'text-white-1000 bg-black-1000' : ''}
  `}
>
  <span class="max-sm:text-5.5 text-28px block leading-[120%]">
    {dateObject.getDate().toString().padStart(2, '0')}
  </span>
  <span class="max-sm:text-2.25 text-12px block leading-[120%]">
    {dateObject.toLocaleDateString('nl-NL', {
      month: 'short',
      year: 'numeric',
    })}
  </span>
</div>
